import { render, staticRenderFns } from "./JdpAdminUnit.vue?vue&type=template&id=8788fa9c&scoped=true&"
import script from "./JdpAdminUnit.vue?vue&type=script&lang=ts&"
export * from "./JdpAdminUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8788fa9c",
  null
  
)

export default component.exports